import creationToolContainerSelector from './draw_it_creation_tool_container_selector'
import drawItUploadReferenceMediaSelector from './draw_it_upload_reference_media_selector'
import drawItUploadBackgroundImageSelector from './draw_it_upload_background_image_selector'
import saveSelector from './draw_it_save_selector'
import drawItCancelSelector from './draw_it_cancel_selector'
import deleteReferenceMediaSelector from './draw_it_delete_reference_media_selector'
import deleteBackgroundImageSelector from './draw_it_delete_background_image_selector'
import drawItTimerSelector from './draw_it_timer_selector'

export default {
	creationToolContainerSelector,
	drawItUploadReferenceMediaSelector,
	drawItUploadBackgroundImageSelector,
	saveSelector,
	drawItCancelSelector,
	drawItTimerSelector,
	deleteReferenceMediaSelector,
	deleteBackgroundImageSelector,
}
